import { cn } from '@repo/ui/lib/utils'
import { createContext, type ReactNode, useContext, useLayoutEffect, useState } from 'react'

const TopBarActionsValueContext = createContext<ReactNode>(null)
const TopBarActionsSetterContext = createContext<((actions: ReactNode) => void) | null>(null)

export function TopBarActionsProvider({ children }: { children: ReactNode }) {
  const [actions, setActions] = useState<ReactNode>(null)

  return (
    <TopBarActionsSetterContext.Provider value={setActions}>
      <TopBarActionsValueContext.Provider value={actions}>
        {children}
      </TopBarActionsValueContext.Provider>
    </TopBarActionsSetterContext.Provider>
  )
}

export function TopBarActionsSlot() {
  const actions = useContext(TopBarActionsValueContext)
  return <div className="app-topbar-actions-slot">{actions}</div>
}

export function AppTopBarActions({ children }: { children: ReactNode }) {
  const setActions = useContext(TopBarActionsSetterContext)

  if (!setActions) {
    throw new Error('AppTopBarActions must be used within TopBarActionsProvider.')
  }

  useLayoutEffect(() => {
    setActions(children)
  }, [children, setActions])

  useLayoutEffect(() => () => setActions(null), [setActions])

  return null
}

export function AppTopBarActionGroup({
  children,
  className,
}: {
  children: ReactNode
  className?: string
}) {
  return <div className={cn('flex items-center justify-end gap-2', className)}>{children}</div>
}
